export const placeStyles = {
  box: {
    margin: "auto",
  },
  container: {
    margin: {
      mobile: "7.5rem 0.75rem",
      laptop: "10.313rem 10rem",
      desktop: "10.313rem auto",
    },
    maxWidth: "69.438rem",
    alignItems: "center",
    justifyContent: "space-between",
  },
};
